import Select, { createFilter } from 'react-select'
import {
  filterNewApprovalPhotos,
  filterNewGalleryPhotos,
  getMultiObjectFromValue,
  getMultiValueFromObject
} from '../Functions'
import update from 'immutability-helper'
import React from 'react'

const ClassmatesSearch = ({
  classmateOptions,
  state,
  setState,
  varNames
}) => {
  const { [`${varNames.classmates}`]: classmates } = state
  const callbacks = {
    filterNewGalleryPhotos: ({ state, setState, varNames }) => {
      filterNewGalleryPhotos({ state, setState, varNames })
    },
    filterNewApprovalPhotos: ({ state, setState, varNames }) => {
      filterNewApprovalPhotos({ state, setState, varNames })
    }
  }

  return (
    <div className='search-classmates'>
      <Select
        isMulti
        className='photos-search-container'
        options={classmateOptions}
        placeholder='Select classmates...'
        onChange={(classmates) => {
          callbacks[`${varNames.callback}`]({
            state: update(state, {
              [`${varNames.classmates}`]: { $set: getMultiValueFromObject(classmates) }
            }),
            setState: (state) => setState(state),
            varNames
          })
        }}
        value={getMultiObjectFromValue(classmates, classmateOptions)}
        filterOptions={createFilter({ ignoreCase: true, ignoreAccents: true })}
      />
    </div>
  )
}

export default ClassmatesSearch
